import { FormContent } from './form-content';

export { FormContent };
